import { useSaveToDesignBoard } from '~/modules/design-board';
import { useVariantSelectionState } from '../context/VariantSelectionContext';

export const useFavouriteVariant = (productID?: number) => {
    const { selectedVariant } = useVariantSelectionState();

    const urlSearchParams =
        productID && selectedVariant?.SKU
            ? new URLSearchParams({
                  sku: selectedVariant.SKU,
              })
            : undefined;

    const { favouriteItem } = useSaveToDesignBoard(
        'ProductPin',
        productID,
        urlSearchParams?.toString()
    );

    return favouriteItem;
};
